module.exports = __webpack_public_path__ + "static/media/vehicle.1c27fd72.svg";